export const pictureParamsData = [
  {
    tag: 'F1',
    left: 12,
    top: 62.3,
    width: 18,
    height: 26.2,
  },
  {
    tag: 'F2',
    left: 44.2,
    top: 62.3,
    width: 18,
    height: 26.2,
  },
  {
    tag: 'F3',
    left: 77.7,
    top: 62.3,
    width: 18,
    height: 26.2,
  },
  {
    tag: 'F4',
    left: 111.3,
    top: 62.3,
    width: 18,
    height: 26.2,
  },
  {
    tag: 'F5',
    left: 142.3,
    top: 62.3,
    width: 18,
    height: 26.2,
  },
  {
    tag: 'F6',
    left: 173.2,
    top: 62.3,
    width: 18,
    height: 26.2,
  },
];
